export default function Skills() {
  const languages = [
    { name: "TypeScript" },
    { name: "Python" },
    { name: "Java" },
    { name: "JavaScript" },
    { name: "C#" },
  ];

  const frontend = [
    { name: "React" },
    { name: "Tailwind CSS" },
    { name: "Redux Toolkit" },
    { name: "React Query" },
  ];

  const backend = [
    { name: "FastAPI" },
    { name: "Flask" },
    { name: "Hono" },
    { name: "Spring Boot" },
    { name: "ASP.NET Core" },
    { name: "REST APIs" },
    { name: "Drizzle ORM" },
    { name: "Entity Framework Core" },
  ];

  const cloudAi = [
    { name: "Azure AI Foundry" },
    { name: "AWS Bedrock" },
    { name: "Azure AI Search" },
    { name: "RAG" },
    { name: "MCP" },
    { name: "Kubernetes" },
    { name: "LLM Observability" },
  ];

  const dataDevops = [
    { name: "PostgreSQL" },
    { name: "MongoDB" },
    { name: "Milvus" },
    { name: "Docker" },
    { name: "GitHub Actions" },
  ];

  const renderSkillPill = (name, delayClass) => {
    return (
      <div
        className={`bg-white/[0.03] border border-white/10 hover:border-[#f15700] text-gray-300 hover:text-white font-medium rounded-full px-5 py-2.5 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-[0_0_15px_rgba(241,87,0,0.2)] animate__animated ${delayClass}`}
      >
        {name}
      </div>
    );
  };

  return (
    <section id="skills" className="relative py-24 md:py-32 border-t border-white/5">
      {/* Subtle Background Glow */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[300px] h-[300px] bg-[#f15700] opacity-[0.03] blur-[120px] rounded-full pointer-events-none"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-20 animate__animated">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Technical <span className="text-[#f15700]">Skills</span>
          </h2>
          <div className="w-20 h-1.5 bg-[#f15700] rounded-full mx-auto"></div>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16">
          <div className="flex flex-col">
            <h3 className="text-2xl font-bold mb-8 text-white flex items-center gap-3 animate__animated custom-delay-3">
              <svg className="w-6 h-6 text-[#f15700]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path></svg>
              Languages
            </h3>
            <div className="flex flex-wrap gap-3">
              {languages.map((skill, index) =>
                <div key={index}>{renderSkillPill(skill.name, "custom-delay-4")}</div>
              )}
            </div>
          </div>

          <div className="flex flex-col">
            <h3 className="text-2xl font-bold mb-8 text-white flex items-center gap-3 animate__animated custom-delay-3">
              <svg className="w-6 h-6 text-[#f15700]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
              Frontend
            </h3>
            <div className="flex flex-wrap gap-3">
              {frontend.map((skill, index) =>
                <div key={index}>{renderSkillPill(skill.name, "custom-delay-4")}</div>
              )}
            </div>
          </div>
          
          <div className="flex flex-col">
            <h3 className="text-2xl font-bold mb-8 text-white flex items-center gap-3 animate__animated custom-delay-4">
              <svg className="w-6 h-6 text-[#f15700]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"></path></svg>
              Backend
            </h3>
            <div className="flex flex-wrap gap-3">
              {backend.map((skill, index) =>
                <div key={index}>{renderSkillPill(skill.name, "custom-delay-5")}</div>
              )}
            </div>
          </div>
          
          <div className="flex flex-col">
            <h3 className="text-2xl font-bold mb-8 text-white flex items-center gap-3 animate__animated custom-delay-4">
              <svg className="w-6 h-6 text-[#f15700]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"></path></svg>
              Cloud & AI
            </h3>
            <div className="flex flex-wrap gap-3">
              {cloudAi.map((skill, index) => <div key={index}>{renderSkillPill(skill.name, "custom-delay-5")}</div>)}
            </div>
          </div>

          <div className="flex flex-col">
            <h3 className="text-2xl font-bold mb-8 text-white flex items-center gap-3 animate__animated custom-delay-5">
              <svg className="w-6 h-6 text-[#f15700]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"></path></svg>
              Data & DevOps
            </h3>
            <div className="flex flex-wrap gap-3">
              {dataDevops.map((skill, index) => <div key={index}>{renderSkillPill(skill.name, "custom-delay-6")}</div>)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
